import AppBar from 'components/AppBar'

export default function Admin() {
  return (
    <div className='App'>
      <header className='App-header'>
        <AppBar />
      </header>
    </div>
  )
}
